<template>
  <v-card flat dense>
    <v-form ref="form" v-model="valid">
      <v-card-title>
        {{ $t('EREPORTER.INVOICES.BILLING_ADDRESS') }}
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('cancel')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-select
              v-model="form.addressable_id"
              name="addressable_id"
              item-text="address"
              item-value="addressable_id"
              :items="addresses"
              :label="$t('ITEM.ADDRESS')"
              :rules="rules.addressable_id"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-btn outlined depressed color="grey" @click="$emit('cancel')">
            {{ $t('BUTTON.CANCEL') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" :disabled="!valid" @click="update">
            {{ $t('BUTTON.UPDATE') }}
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import { notEmpty } from '@/modules/_global/variables/rules';
import { mapActions } from 'vuex';
import customerTypes from '@/modules/ereporter/common/Invoices/customerTypes';

export default {
  name: 'UpdateAddress',

  props: {
    customerType: {
      type: Number,
      required: true,
      validator: prop => Object.values(customerTypes).includes(prop)
    },
    customerId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      valid: true,
      form: {
        addressable_id: null
      },
      addresses: [],
      rules: {
        addressable_id: [notEmpty]
      }
    };
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapActions('ereporter', ['getCustomerAddresses']),

    refreshData() {
      this.getCustomerAddresses({
        params: {
          customer_id: this.customerId,
          customer_type: this.customerType
        }
      }).then(({ data }) => {
        this.addresses = data.data;
      });
    },

    update() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.$emit(
        'update',
        this.addresses.find(
          obj => obj.addressable_id === this.form.addressable_id
        )
      );
    }
  }
}
</script>